import "./resource-show-main.css";

import "./img/ellipsis.png";

import 'ez-styles/assets/javascripts/ez-styles/utils/tooltips';